import React from 'react';
import { HashLink as HashLink } from 'react-router-hash-link';

function Footer() {

    return (

        <>

            <section className='footer'>
                <div className='footer-con'>
                    <div className='socials'>
                        <a href='https://discord.gg/ucPaKkFfUE' target='_blank'>
                            <img src="./images/discord.png" alt="discord" />
                        </a>
                        <a href='https://twitter.com/LegacyFriends_' target='_blank'>
                            <img src="./images/twitter.png" alt="twitter" />
                        </a>
                        <div className='f-logo'>
                            <a href='./' target='_blank'>
                                <img src="./images/logo.png" alt="Logo" />
                            </a>
                        </div>
                        <a href='https://opensea.io/collection/legacyfriends-alpha' target='_blank'>
                            <img src="./images/opensia.png" alt="instagram" />
                        </a>
                        <a href='https://www.instagram.com/legacyfriends.xyz/' target='_blank'>
                            <img src="./images/instagram.png" alt="instagram" />
                        </a>
                    </div>
                    <div className='copyright'>
                        <p>LegacyFriends 2022 all right reserved</p>
                    </div>
                    <div className='nft-constructer'>
                        <p>BROUGHT TO YOU BY
                            <a href='https://www.nftconstructer.com/' target='_blank'><img src="./images/nft-constructor.png" alt="NFT CONSTRUCTER" />NFT CONSTRUCTER</a>
                        </p>
                    </div>
                    <div className='footer-nav'>
                        <ul>
                            <li><HashLink to='./#intro'>Home</HashLink></li>
                            <li><HashLink to='./#roadmap'>Roadmap</HashLink></li>
                            <li><HashLink to='./#team'>Team</HashLink></li>
                            <li><HashLink href='https://discord.gg/ucPaKkFfUE'>Discord</HashLink></li>
                            {/* <li><HashLink href=''>Faq</HashLink></li> */}
                        </ul>

                    </div>

                </div>


            </section>

        </>

    )

}

export default Footer;



